import { NumberInputFormik, TextInputFormik } from '@strata/react-inputs';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { getIn, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import { ActivationTypes } from 'components/valueCase/helpers';

const ActivationTypesList = [
    {
        name: 'On Claim',
        value: ActivationTypes.ON_CLAIM,
    },
    {
        name: 'On Start',
        value: ActivationTypes.ON_START,
    },
    {
        name: 'On Day',
        value: ActivationTypes.ON_DAY,
    },
];

export const TaskDetails = ({ id = undefined, disabled = undefined }) => {
    const formik = useFormikContext();
    const idPrefix = id ? `${id}.` : '';
    const showDays = getIn(formik.values, `${idPrefix}activation_type`) === ActivationTypes.ON_DAY;
    return (
        <div className="sds_performance__flex-row">
            <TextInputFormik
                id={`${idPrefix}task_name`}
                placeholderText="Enter Task Name"
                disabled={disabled}
                required
                label="Task Name"
            />
            <SuggestSingleSelectFormik
                id={`${idPrefix}activation_type`}
                placeholderText="Select Activation Type"
                disabled={disabled}
                label="Activation Type"
                required
                values={ActivationTypesList}
                onChange={(newValue) =>
                    formik.setFieldValue(`${idPrefix}activation_type`, newValue.value)
                }
                selectedItem={
                    ActivationTypesList.filter(
                        (type) => type.value === getIn(formik.values, `${idPrefix}activation_type`),
                    )[0]?.name
                }
            />
            {showDays && (
                <NumberInputFormik
                    id={`${idPrefix}on_day_days`}
                    label="Days"
                    disabled={disabled}
                    required
                    helperText="The number of days after the performance start to create the task"
                />
            )}
        </div>
    );
};

TaskDetails.propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
};
